import { useEffect } from 'react';
import type { ReactNode } from 'react';
import L from 'leaflet';
import { MapContainer as LeafletMapContainer, TileLayer, useMap } from 'react-leaflet';
import { mapService } from '../services/map.service';

// Fix Leaflet default icon paths broken by Vite's asset handling
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

delete (L.Icon.Default.prototype as unknown as Record<string, unknown>)._getIconUrl;
L.Icon.Default.mergeOptions({ iconUrl, iconRetinaUrl, shadowUrl });

function MapFlyTo() {
  const map = useMap();
  useEffect(() => {
    const sub = mapService.flyTo$.subscribe(({ lat, lng, zoom }) => {
      map.flyTo([lat, lng], zoom);
    });
    return () => sub.unsubscribe();
  }, [map]);
  return null;
}

function InvalidateSize({ sizeKey }: { sizeKey: unknown }) {
  const map = useMap();
  useEffect(() => {
    const id = setTimeout(() => map.invalidateSize(), 210);
    return () => clearTimeout(id);
  }, [sizeKey, map]);
  return null;
}

interface MapContainerProps {
  children?: ReactNode;
  sizeKey?: unknown;
}

// Velenje, Slovenia — default center
const DEFAULT_CENTER: [number, number] = [46.359, 15.117];
const DEFAULT_ZOOM = 14;

export function MapContainer({ children, sizeKey }: MapContainerProps) {
  return (
    <LeafletMapContainer
      center={DEFAULT_CENTER}
      zoom={DEFAULT_ZOOM}
      style={{ height: '100%', width: '100%' }}
      zoomControl={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapFlyTo />
      <InvalidateSize sizeKey={sizeKey} />
      {children}
    </LeafletMapContainer>
  );
}
